<template>
    <div class="examData-wrapper">
<!--        <div class="top-tab" :class="role === '3' ? '' : 'tabs'">-->
<!--            <el-tabs v-model="tabName" class="tabs-full" @tab-click="toggleTab" v-if="role === '3'">-->
<!--                <el-tab-pane label="理论题" name="evaluationCenterTheoreticalQuestionsIndex"></el-tab-pane>-->
<!--                <el-tab-pane label="商品信息采集与处理" name="evaluationCenterGoodsInfoIndex"></el-tab-pane>-->
<!--                <el-tab-pane label="网店装修" name="evaluationCenterOnlineShopDecorationIndex"></el-tab-pane>-->
<!--                <el-tab-pane label="网络推广" name="evaluationCenterWebPromotionIndex"></el-tab-pane>-->
<!--            </el-tabs>-->
<!--            <el-tabs v-model="tabName" class="tabs-full" @tab-click="toggleTab" v-if="role === '4'">-->
<!--                <el-tab-pane label="理论题" name="judgesTheoreticalQuestionsIndex"></el-tab-pane>-->
<!--                <el-tab-pane label="商品信息采集与处理" name="judgesGoodsInfoIndex"></el-tab-pane>-->
<!--                <el-tab-pane label="网店装修" name="judgesOnlineShopDecorationIndex"></el-tab-pane>-->
<!--                <el-tab-pane label="网络推广" name="judgesWebPromotionIndex"></el-tab-pane>-->
<!--            </el-tabs>-->
<!--            <div class="right">-->
<!--                <el-button type="primary" @click="goBack">返回</el-button>-->
<!--            </div>-->
<!--        </div>-->
        <div class="container">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tabName: '',
                role: ''
            }
        },
        created() {
            this.role = localStorage.getItem('role');
            this.tabName = this.$route.meta.tabName;
        },
        methods: {
            toggleTab(tab) {
                this.$router.push({
                    name: tab.name,
                    query:{
                      type: this.$route.query.type, // 是否批改 提交
                      examId: this.$route.query.examId
                    }
                })
            },
            goBack() {
                if (this.role === '3') {
                    this.$router.push({
                        path: '/evaluationCenter/scoreManagement',
                    })
                } else {
                    this.$router.push({
                        path: '/judges/grading/index',
                    })
                }

            }
        }
    }
</script>

<style scoped lang="scss">
    .examData-wrapper {
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        .container {
            height: 1%;
            flex: 1;
            position: relative;
        }
    }
    .tabs {
        margin: 20px 20px 0 !important;
    }
    .top-tab {
        margin: 0 20px 0;
        display: flex;
        justify-content: space-between;
        position: relative;
        &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 1px;
            background: #F1F5FF;
        }
        .right {
            width: 90px;
            text-align: right;
            margin-top: -5px;
        }
    }
    .tabs-full {
        width: 1%;
        flex: 1;
        ::v-deep {
            .el-tabs__nav-wrap::after {
                content: none;
            }
            .el-tabs__header {
                margin-bottom: 0;
            }
            .el-tabs__active-bar {
                display: none;
            }
            .el-tabs__item {
                height: 46px;
                line-height: 46px;
                font-size: 16px;
                font-weight: normal;
                border-radius: 4px 4px 0 0;
                &.is-active {
                    background: #E7F6EF;
                }
            }
            .el-tabs__item.is-top:nth-child(2) {
                padding-left: 20px;
            }
            .el-tabs__item.is-top:last-child {
                padding-right: 20px;
            }
        }
    }
</style>